import React from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import Summary from './Summary';
import ComplementoRow from './ComplementoRow';
import { AccordionWrapper } from '../../../drawer_styles';
import { useSimpleProduct } from '../../../../../../../hooks/newSimpleProduct';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    accordionItem: {
      borderTopLeftRadius: '0 !important',
      borderTopRightRadius: '0 !important',
      margin: '0 !important',
    },
    accordionDetails: {
      display: 'block',
      paddingTop: '0',
    },
  }),
);

const AcordeaoComplementos: React.FC = () => {
  const classes = useStyles();
  const { complemento, itensComplemento } = useSimpleProduct();

  return (
    <>
      {complemento.map((item) => (
        <AccordionWrapper>
          <div className={classes.root}>
            <Accordion className={classes.accordionItem}>
              <Summary
                index={item.index}
                title={item.descricao}
                isObrigatorio={item.complemento_obrigatorio}
              />

              <AccordionDetails className={classes.accordionDetails}>
                {itensComplemento.map((item_complemento) => (
                  <>
                    {item_complemento.index_complemento === item.index && (
                      <ComplementoRow
                        descricao={item_complemento.descricao}
                        preco={item_complemento.preco.toString()}
                      />
                    )}
                  </>
                ))}
              </AccordionDetails>
            </Accordion>
          </div>
        </AccordionWrapper>
      ))}
    </>
  );
};

export default AcordeaoComplementos;
